module.exports = __webpack_public_path__ + "img/3.d80bfb88.jpg";